var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    {
      class: { "full-height": _vm.$wf.isSmDown },
      attrs: { "max-width": "1000" },
    },
    [
      _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("price-cat-edit")))]),
      _c(
        "w-scroll-view",
        { attrs: { tag: "w-card-content" } },
        [
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("w-input", {
                    attrs: { fancy: "", label: _vm.$t("alias").toString() },
                    model: {
                      value: _vm.value.Name,
                      callback: function ($$v) {
                        _vm.$set(_vm.value, "Name", $$v)
                      },
                      expression: "value.Name",
                    },
                  }),
                ],
                1
              ),
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("w-checkbox", {
                    attrs: { space: "", label: _vm.$ct("default-active") },
                    model: {
                      value: _vm.value.Active,
                      callback: function ($$v) {
                        _vm.$set(_vm.value, "Active", $$v)
                      },
                      expression: "value.Active",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c("w-divider"),
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("w-checkbox", {
                    attrs: {
                      space: "",
                      label: _vm.$ct("calculate-via-price-clause"),
                    },
                    model: {
                      value: _vm.value.CalculateViaPriceClause,
                      callback: function ($$v) {
                        _vm.$set(_vm.value, "CalculateViaPriceClause", $$v)
                      },
                      expression: "value.CalculateViaPriceClause",
                    },
                  }),
                ],
                1
              ),
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("w-checkbox", {
                    attrs: {
                      space: "",
                      label: _vm.$ct(
                        "calculate-via-price-current-profit-percentage"
                      ),
                    },
                    model: {
                      value: _vm.value.CalculateViaCurrentProfitPercentage,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.value,
                          "CalculateViaCurrentProfitPercentage",
                          $$v
                        )
                      },
                      expression: "value.CalculateViaCurrentProfitPercentage",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c("w-divider"),
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("w-checkbox", {
                    attrs: {
                      space: "",
                      label: _vm.$ct("calculate-via-parameters"),
                    },
                    model: {
                      value: _vm.value.CalculateViaParameters,
                      callback: function ($$v) {
                        _vm.$set(_vm.value, "CalculateViaParameters", $$v)
                      },
                      expression: "value.CalculateViaParameters",
                    },
                  }),
                ],
                1
              ),
              _vm._l(_vm.value.CalculationParameters, function (parameter, i) {
                return _c(
                  "w-col",
                  { key: i, attrs: { xs: "12" } },
                  [
                    _c("app-sell-category-edit-calculation", {
                      attrs: {
                        value: parameter,
                        disabled: !_vm.value.CalculateViaParameters,
                        "delete-disabled":
                          _vm.deleteCalculationParameterDisabled,
                      },
                      on: {
                        delete: function ($event) {
                          return _vm.removeParameter(i)
                        },
                      },
                    }),
                  ],
                  1
                )
              }),
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c(
                    "w-row",
                    [
                      _c("w-spacer"),
                      _c(
                        "w-button",
                        {
                          attrs: { round: "" },
                          on: {
                            click: function ($event) {
                              return _vm.addParameter()
                            },
                          },
                        },
                        [_c("w-fa", { attrs: { icon: "plus" } })],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            2
          ),
          _c("w-divider"),
          _c(
            "w-row",
            [
              _c("w-col", { attrs: { xs: "12" } }, [
                _c("div", { staticClass: "control-padding" }, [
                  _vm._v(" " + _vm._s(_vm.$ct("handle-this-price")) + " "),
                  _c(
                    "div",
                    { staticClass: "input-container" },
                    [
                      _c("w-input-number", {
                        model: {
                          value: _vm.value.LowerHandleValue,
                          callback: function ($$v) {
                            _vm.$set(_vm.value, "LowerHandleValue", $$v)
                          },
                          expression: "value.LowerHandleValue",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" " + _vm._s(_vm.$t("common.and")) + " "),
                  _c(
                    "div",
                    { staticClass: "input-container" },
                    [
                      _c("w-input-number", {
                        model: {
                          value: _vm.value.UpperHandleValue,
                          callback: function ($$v) {
                            _vm.$set(_vm.value, "UpperHandleValue", $$v)
                          },
                          expression: "value.UpperHandleValue",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _c("w-spacer"),
      _c(
        "w-card-actions",
        [
          _c(
            "w-button",
            {
              staticClass: "cancel",
              on: {
                click: function ($event) {
                  return _vm.cancel()
                },
              },
            },
            [_vm._v(" " + _vm._s(_vm.$t("common.cancel")) + " ")]
          ),
          _c("w-spacer"),
          _c(
            "w-button",
            {
              on: {
                click: function ($event) {
                  return _vm.save()
                },
              },
            },
            [_vm._v(" " + _vm._s(_vm.$t("common.save")) + " ")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }